// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__C3PM6","item":"Nav_item__zSqWi"};